
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.952 1.703c.348.065.578.4.512.749L6.17 4.025h2.778l.34-1.81a.642.642 0 111.26.237l-.294 1.573h1.414a.642.642 0 110 1.283h-1.655l-.634 3.384h1.706a.642.642 0 010 1.283H9.137l-.34 1.81a.642.642 0 01-1.26-.237l.294-1.573H5.054l-.34 1.81a.642.642 0 01-1.261-.237l.295-1.573H2.334a.642.642 0 010-1.283h1.655l.634-3.384H2.917a.642.642 0 010-1.283h1.947l.339-1.81a.642.642 0 01.749-.512zm-.023 3.605l-.635 3.384h2.778l.634-3.384H5.93z","fill":"#58697D"}})])
          )
        }
      }
    